/**
 * Formats a list of sports for display.
 * If there are more than 3 sports, returns ['ALL SPORTS'] instead of the full list.
 *
 * @param sportsList - Array of sport names (strings)
 * @returns Array containing either all sports or ['ALL SPORTS'] if more than 3, or undefined if empty/null
 */
export const formatSportsForDisplay = (
  sportsList: string[] | null | undefined
): string[] | undefined => {
  if (!sportsList || sportsList.length === 0) {
    return undefined;
  }

  return sportsList.length > 3 ? ['ALL SPORTS'] : sportsList;
};
